import api from '@/apis'
import { API_PREFIX } from '@/constants'

export interface SealedItemStockResponse {
  /** 남은 재고 수량 — 선택 수량과 비교 대상 */
  stock: number
  /** 판매 여부 — false 면 수량 무관 신청 불가 */
  isOnSale: boolean
}

/**
 * 밀봉비닐 봉투 재고/판매여부 원본 조회 — GET /order/api/v2/product-orders/item-check.
 *
 * 응답 envelope: `{ data: { stock: number, isOnSale: boolean } }`.
 *  - isOnSale: 판매 중인지 (false 면 수량과 무관하게 신청 불가)
 *  - stock: 남은 재고 수량 (선택 수량과 비교해야 함 — 1개 남았는데 2개 신청 차단)
 */
export const apiGetSealedItemStock = async (): Promise<SealedItemStockResponse> => {
  return api.get<SealedItemStockResponse>(`${API_PREFIX.ORDER}/product-orders/item-check`)
}
